export default [
  //宣纸之名
  {
    path: "/culture/name",
    name: "CultureName",
    title: "宣纸之名",
    component: () => import("@/views/culture/name/name.vue"),
    meta: {
      name: "CultureName",
      pageName: "culture",
    },
  },
  //宣纸历史
  {
    path: "/culture-hisotry",
    title: "宣纸历史",
    name: "CultureHisotry",
    component: () => import("@/views/culture/history/index.vue"),
    children: [
      {
        path: "/culture/history",
        name: "CultureHisotry",
        component: () => import("@/views/culture/history/history.vue"),
      },
      // {
      //   path: "/culture/family",
      //   name: "CultureFamily",
      //   component: () => import("@/views/culture/history/family.vue"),
      // },
      {
        path: "/culture/oral-history",
        name: "CultureOralHistory",
        component: () => import("@/views/culture/history/oral-history.vue"),
      },
    ],
  },
  //宣纸技艺
  {
    path: "/culture-workmanship",
    component: () => import("@/views/culture/workmanship/index.vue"),
    title: "宣纸技艺",
    name: "CultureMaterial",
    children: [
      {
        path: "/culture/material",
        title: "制作材料",
        name: "CultureMaterial",
        component: () => import("@/views/culture/workmanship/material.vue"),
      },
      {
        path: "/culture/tool",
        title: "工具",
        name: "CultureTool",
        component: () => import("@/views/culture/workmanship/tool.vue"),
      },
      {
        path: "/culture/processes-detail",
        title: "制作工序",
        name: "CultureToolDetail",
        component: () => import("@/views/culture/workmanship/detail.vue"),
        meta: {
          name: "CultureTool",
        },
      },
      {
        path: "/culture/processes",
        title: "制作工序",
        name: "CultureProcesses",
        component: () => import("@/views/culture/workmanship/processes.vue"),
      },
      {
        path: "/culture/processes-detail",
        title: "制作工序",
        name: "CultureProcessesDetail",
        component: () => import("@/views/culture/workmanship/detail.vue"),
        meta: {
          name: "CultureProcesses",
        },
      },
    ],
  },
  //宣纸承载
  {
    // name: "bearing",
    path: "/culture/bearing",
    title: "宣纸承载",
    component: () => import("@/views/culture/bearing/index.vue"),
    name: "CultureBearing",
    meta: {
      name: "CultureProcesses",
      pageName: "culture",
    },
    // children: [
    //   {
    //     path: "/culture/bearing",
    //     title: "制作工序",
    //     name: "CultureWorkmanshipsDetail",
    //     component: () => import("@/views/culture/bearing/detail.vue"),
    //     meta: {
    //       name: "CultureProcesses",
    //     },
    //   },
    // ],
  },
  //宣纸传承
  {
    path: "/culture-inherit",
    title: "宣纸传承",
    name: "CultureWay",
    component: () => import("@/views/culture/inherit/index.vue"),
    children: [
      {
        path: "/culture/inherit",
        name: "CultureInherit",
        title: "非遗传承",
        component: () => import("@/views/culture/inherit/inherit.vue"),
      },
      {
        path: "/culture/way",
        title: "家族式传承",
        name: "CultureWay",
        component: () => import("@/views/culture/inherit/way.vue"),
      },
      {
        path: "/culture/society",
        title: "社会化传承",
        name: "CultureWaySociety",
        component: () => import("@/views/culture/inherit/society.vue"),
      },
      {
        path: "/culture/inheritor-detail",
        title: "传承方式",
        name: "CultureInheritorDetail",
        component: () => import("@/views/culture/inherit/detail.vue"),
        meta: {
          name: "CultureInherit",
        },
      },
    ],
  },
  {
    path: "/culture/reservation",
    hide: true,
    title: "预约",
    name: "CultureReservation",
    component: () => import("@/views/culture/reservation/index.vue"),
    meta: {
      name: "CultureInherit",
    },
  },
  //宣纸知识
  {
    path: "/culture-leanrn",
    title: "宣纸知识",
    component: () => import("@/views/culture/learn/index.vue"),
    name: "CultureClassification",
    children: [
      {
        path: "/culture/classification",
        name: "CultureClassification",
        title: "宣纸的分类",
        component: () => import("@/views/culture/learn/classification.vue"),
      },
      {
        path: "/culture/identify",
        name: "CultureIdentify",
        title: "宣纸的保存",
        component: () => import("@/views/culture/learn/identify.vue"),
      },
      {
        path: "/culture/save",
        title: "宣纸的鉴别",
        name: "CultureSave",
        component: () => import("@/views/culture/learn/save.vue"),
      },
      {
        path: "/culture/characteristic",
        title: "宣纸的特性",
        name: "CultureCharacteristic",
        component: () => import("@/views/culture/learn/characteristic.vue"),
      },

    ],
  },
  //宣纸非遗
  {
    title: "宣纸非遗",
    path: "/culture/heritage",
    name: "CultureHeritage",
    component: () => import("@/views/culture/heritage/heritage.vue"),
    meta: {
      name: "CultureName",
      pageName: "culture",
    },
  },
].map((item) => {
  if (item.children) {
    item.children.forEach((childItem) => {
      // childItem.pageName = "culture"
      if (childItem.meta) {
        childItem.meta.parentName = item.name
        childItem.meta.pageName = "culture"
      } else {
        childItem.meta = { parentName: item.name, pageName: "culture" }
      }
    })
  }
  return item
})
